<ng-container *ngIf="newTab; else elseBlock">
  <div class="col-12">
    <h1 class="h2 mb-7">{{ 'habaCustomerData.orderStatus.headline' | cxTranslate }}</h1>
    <p [innerHTML]="'habaCustomerData.orderStatus.info' | cxTranslate"></p>
    <br />
  </div>
  <div class="col-12 col-md-8 col-lg-6">
    <ng-container *ngTemplateOutlet="input" />
  </div>
  <p class="col-12">
    {{ 'habaContactForm.whenStuck' | cxTranslate }}
    <a [routerLink]="contactFormUrl" target="_blank" rel="noopener noreferrer">
      {{ 'habaContactForm.formular' | cxTranslate }}</a
    >.
  </p>
</ng-container>
<ng-template #elseBlock>
  <div class="row">
    <div class="col-12 col-lg-3 pr-lg-5">
      <ng-container *ngTemplateOutlet="input" />
    </div>
    <div class="col-12 col-lg-9 border-left d-flex pl-lg-5">
      <ng-container *ngTemplateOutlet="order" />
    </div>
  </div>
</ng-template>

<ng-template #order>
  <app-my-orders-details
    [s4Customer]="s4CustomerNumber"
    [s4Order]="s4OrderNumber"
    [myAccount]="false"
  ></app-my-orders-details>
</ng-template>

<ng-template #input>
  <h4>{{ 'habaCustomerData.orderStatus.inputText' | cxTranslate }}</h4>

  <form [formGroup]="orderStatusGroup" class="mt-7">
    <app-form-input>
      <app-form-label>{{
        'habaCustomerData.orderStatus.customerNumberText' | cxTranslate
      }}</app-form-label>
      <input
        appFormInput
        type="number"
        formControlName="customerNr"
        (input)="validateInputLength($event, 10)"
        (keydown)="preventInvalidNumericChars($event)"
        min="0"
      />
      <app-form-error *ngIf="orderStatusGroup.get('customerNr')?.errors?.['required']">
        {{ 'habaCustomerData.orderStatus.inputError' | cxTranslate }}
      </app-form-error>
      <app-form-error *ngIf="orderStatusGroup.get('customerNr')?.errors?.['pattern']">
        {{ 'habaCustomerData.orderStatus.customerNrFormatError' | cxTranslate }}
      </app-form-error>
    </app-form-input>
    <app-form-input>
      <app-form-label>{{
        'habaCustomerData.orderStatus.orderNumberText' | cxTranslate
      }}</app-form-label>
      <input
        appFormInput
        type="number"
        formControlName="orderNr"
        (input)="validateInputLength($event, 10)"
        (keydown)="preventInvalidNumericChars($event)"
        min="0"
      />
    </app-form-input>

    <ul class="order-number-criteria">
      <li [ngClass]="getOrderNumberCriterionClass('startsWithNineAndTenDigits')">
        <app-svg iconName="Check" dimension="1rem" />
        {{ 'habaCustomerData.orderStatus.startsWithNineAndTenDigits' | cxTranslate }}
      </li>
      <li [ngClass]="getOrderNumberCriterionClass('onlyDigits')">
        <app-svg iconName="Check" dimension="1rem" />
        {{ 'habaCustomerData.orderStatus.onlyDigits' | cxTranslate }}
      </li>
    </ul>

    <div class="form-group mt-9">
      <button
        class="btn btn-primary btn-full"
        (click)="getOrderStatus()"
        [disabled]="orderStatusGroup.invalid"
      >
        {{ 'habaCustomerData.orderStatus.submitText' | cxTranslate }}
        <span class="pl-4">
          <app-svg iconName="Search" dimension="1.5rem" />
        </span>
      </button>
    </div>
  </form>
</ng-template>
